"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
const react_1 = __importDefault(require("react"));
const View_1 = require("@amzn/atoz-web/View");
const MessageBanner_1 = require("@amzn/atoz-web/MessageBanner");
const Link_1 = require("@amzn/atoz-web/Link");
const Icons_1 = require("@amzn/atoz-web/Icons");
const ErrorPage = ({ errorMessage, additionalInfo }) => {
    return (react_1.default.createElement(View_1.View, { style: {
            alignSelf: 'center',
            margin: 'S400',
            paddingTop: '2rem',
            width: '80%'
        } },
        react_1.default.createElement(MessageBanner_1.MessageBanner, { type: MessageBanner_1.MessageBannerType.Warning, dataTestId: "ErrorMessageBanner" },
            errorMessage,
            additionalInfo && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_1.default.Fragment, null, additionalInfo.message),
                react_1.default.createElement(Link_1.Link, { href: additionalInfo.redirectLink, target: "_blank", icon: react_1.default.createElement(Icons_1.IconExternalLink, null) }, additionalInfo.redirectLinkText))))));
};
exports.ErrorPage = ErrorPage;
